import { useStore } from '@/stores/index'


export const useGA = () => {
	const store = useStore()

	const pushGAEvent = (eventName) => {

	
		window.dataLayer = window.dataLayer || []
		window.dataLayer.push({
			event: 'horyuken_event',
			uid: store.userId,
			event_name: eventName,
			event_time:new Date().toLocaleString() // 事件時間
		})
		// console.log('[GA] 進站事件已推送', window.dataLayer[window.dataLayer.length - 1])
	}

	return { pushGAEvent }
}
